export const removeLinks = (text: string) => {
    return text.replace(/<a[^>]*>(.*?)<\/a>/gi, '$1');
};
